import { render, staticRenderFns } from "./ElectronMenu.vue?vue&type=template&id=2ba3f1aa&scoped=true"
import script from "./ElectronMenu.vue?vue&type=script&lang=js"
export * from "./ElectronMenu.vue?vue&type=script&lang=js"
import style0 from "./ElectronMenu.vue?vue&type=style&index=0&id=2ba3f1aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba3f1aa",
  null
  
)

export default component.exports